import { render, staticRenderFns } from "./FCellDocumentLink.vue?vue&type=template&id=566cb72b&"
import script from "./FCellDocumentLink.vue?vue&type=script&lang=ts&"
export * from "./FCellDocumentLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports